import { ListItem, ListItemIcon, Tooltip } from '@mui/material';

import ListItemButtonLink from '../../ListItemButtonLink';
import type { MenuOption } from '../menu';
import { isInPaths } from '../utils';

import { ListHeaderText, ListItemText, RailDivider, StyledList } from './index.styles';

interface MenuListProps {
  source: MenuOption[];
  header?: string | undefined;
  currentPath?: string | undefined;
  expanded: boolean;
  // Fires before link navigation — used to close the mobile sheet on nav.
  onItemClick?: () => void;
  /** False where nothing sits above the heading for the rail to separate it from. */
  separated?: boolean;
}

const MenuList = ({
  header,
  source,
  currentPath = '',
  expanded,
  onItemClick,
  separated = true,
}: MenuListProps) => (
  <StyledList>
    {header &&
      (expanded ? (
        <ListItem>
          <ListHeaderText
            primary={header}
            slotProps={{
              primary: {
                variant: 'subtitle2',
              },
            }}
          />
        </ListItem>
      ) : (
        separated && <RailDivider />
      ))}
    {source.map(item => {
      // Matches any path under the entry, so the entry is the current item of
      // the set rather than necessarily the current page
      const selected = isInPaths(item.linkedEndpoints, currentPath);
      return (
        <Tooltip key={item.name} title={expanded ? '' : item.name} placement='right'>
          <ListItemButtonLink
            selected={selected}
            aria-current={selected ? 'true' : undefined}
            href={item.href}
            onClick={onItemClick}
            disableRipple
          >
            <ListItemIcon>{selected && item.iconFilled ? item.iconFilled : item.icon}</ListItemIcon>
            <ListItemText
              primary={item.name}
              primaryTypographyProps={{ variant: 'body2' }}
              $expanded={expanded}
            />
          </ListItemButtonLink>
        </Tooltip>
      );
    })}
  </StyledList>
);

export default MenuList;
